import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { TextField, Paper, Typography, Box, IconButton, InputAdornment, InputLabel, Grid2 } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { usePasswordByTokenMutation, useValidateOTPAndUpdatePasswordMutation } from "../../redux/login/login.api";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { useLocation, useNavigate } from "react-router-dom";
import ORLogo from '../../assets/ORhorizontal.svg'
import Forget from '../../assets/forgetPasswod.jpg'
import { Link } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import dayjs from "dayjs";

// Validation Schema
const schema = yup.object().shape({
  emailId: yup.string().email("Enter valid email").required("Email is required")
    .test('Enter valid email', 'Enter valid email', (value) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    }),
  otp: yup.string().required("Secret code is required"),
  newPassword: yup.string().min(6, "Password must be at least 6 characters").required("New password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "Passwords must match")
    .required("Confirm password is required"),
});

const ForgotPasswordLink = () => {

  const { Snackbar } = useContext(SnackbarContext);
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const location = useLocation()
  const { email, response, resetCount } = location?.state || ''

  // State for toggling password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [passwordChange] = useValidateOTPAndUpdatePasswordMutation();
  const alreadyHandled = localStorage.getItem('resetHandled');
  const [resetCountState, setResetCountState] = useState(alreadyHandled ? false : resetCount);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);

  const handlePreventCopyPaste = (event) => {
    event.preventDefault();
  };

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      otp: +data?.otp
    }
    try {
      const result = await passwordChange(payload).unwrap()
      if (result?.status === 'success') {
        Snackbar(result?.message, 'success')
        navigate('/')
      } else {
        Snackbar(result?.message, 'error')
      }
    } catch (error) {
      Snackbar(error?.data?.data[0]?.error_message, 'error')
    }
  };

  const currentTime = (new Date().toLocaleTimeString());
  const otpExpiryTime = new Date(response?.response?.userDetails[0]?.otpExpiryTime)
  const properTime = dayjs( otpExpiryTime).format('HH-mm-ss')

  const [countdown, setCountDown] = useState(15 * 60);
  const [lock, setLock] = useState(true)

  const localTime = localStorage.getItem

  useEffect(() => {
    const navType = performance.getEntriesByType("navigation")[0].type;
    if (navType === "reload") {
      const time = localStorage.getItem('expiryTime')
      setCountDown(time)
    }

    if(email) {
      setValue("emailId" , email)
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          Snackbar("OTP expired. Please request a new one to change your password.", 'error')
          navigate('/')
          return 0;
        }
        localStorage.setItem('expiryTime', prev - 1)
        return prev - 1;

      });

    }, 1000);

    return () => clearInterval(interval);

  }, []);

  useEffect(() => {
    if (resetCountState) {
      setCountDown(15 * 60)
    }
    setTimeout(() => {
      setResetCountState(false)
      localStorage.setItem('resetHandled', 'true');
    }, 0);
  }, [resetCountState])

  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`;
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh">
      <Grid2 sx={{ position: 'absolute', top: 30, left: 50 }}>
        <img src={ORLogo} alt="Logo" style={{ width: "30%", height: '30%' }}></img>
      </Grid2>
      {/* Right Side - Form */}
      <Grid2 sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }}>
        <Grid2 sx={{ display: 'contents' }}>
          <img src={Forget} alt="Logo" style={{ width: "30%", height: '40%', marginTop: '80px' }}></img>
        </Grid2>
        <Grid2>
          <Paper elevation={3} sx={{ padding: 4, width: 400 }}>

            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px' }} onClick={() => navigate('/forget-password')} >
              <ArrowBackIcon sx={{ fontSize: '17px' }} />
              <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>

            <Typography variant="h5" fontWeight="bold" textAlign="center" mb={2}>
              Forgot Password
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <Box mb={2}>
                {/*Email*/}
                <InputLabel className="inputlabels">Email</InputLabel>
                <Controller
                  name="emailId"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      size="small"
                      placeholder="Enter your emailId"
                      className="mailtextfield"
                      // autoComplete="off"
                      InputProps={{
                        readOnly: true
                      }}
                      sx={{
                        "& .MuiFormHelperText-root": { color: "red" },
                      }}
                      error={!!errors.emailId}
                      helperText={errors.emailId?.message}
                    />
                  )}
                />
              </Box>
              {/* Secret Code */}
              <Box mb={2}>
                <InputLabel className="inputlabels">Secret Code</InputLabel>
                <Controller
                  name="otp"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      size="small"
                      placeholder="Enter Secret Code"
                      className="mailtextfield"
                      type="number"
                      sx={{
                        "& .MuiFormHelperText-root": { color: "red" },
                      }}
                      error={!!errors.otp}
                      helperText={errors.otp?.message}
                    />
                  )}
                />
                <Typography sx={{ fontSize: '12px', position: 'relative', left: '10px', marginTop: '5px', color: '#CE2029' }}>The code will expire in {formatTime(countdown)}</Typography>
              </Box>

              {/* New Password with Eye Icon */}
              <Box mb={2}>
                <InputLabel className="inputlabels">New Password</InputLabel>
                <Controller
                  name="newPassword"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      size="small"
                      placeholder="Enter New Password"
                      className="mailtextfield"
                      autoComplete="off"
                      type={showPassword ? "text" : "password"}
                      error={!!errors.newPassword}
                      helperText={errors.newPassword?.message}
                      onPaste={handlePreventCopyPaste}
                      onCopy={handlePreventCopyPaste}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={togglePasswordVisibility} edge="end">
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Box>

              {/* Confirm Password with Eye Icon */}
              <Box mb={2}>
                <InputLabel className="inputlabels">Confirm Password</InputLabel>
                <Controller
                  name="confirmPassword"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      size="small"
                      placeholder="Enter Confirm Password"
                      className="mailtextfield"
                      autoComplete="off"
                      type={showConfirmPassword ? "text" : "password"}
                      error={!!errors.confirmPassword}
                      helperText={errors.confirmPassword?.message}
                      onPaste={handlePreventCopyPaste}
                      onCopy={handlePreventCopyPaste}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleConfirmPasswordVisibility} edge="end">
                              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Box>

              {/* Buttons */}
              <Box mt={3} display="flex" justifyContent="space-between">
                <MUICancelButton onClick={() => reset()} title="Clear" />
                <MUIButton type="submit" title="Submit" />
              </Box>
              {/* <Typography sx={{ fontSize: '14px', position: 'relative', top: 20 }} component={Link} to='/forget-password'>Click here to back</Typography> */}
            </form>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default ForgotPasswordLink;
